import { useEffect, useState } from 'react';
import { useCurrentEquipmentService, useEquipmentCatalog, useEquipmentInventory, useRuntimeEquipmentCatalog } from '@zep/apis';
import { useAuth } from '@zep/auth';
import { getRequestedRuntimeEquipmentCatalogGrants, markRuntimeEquipmentCatalogGrantsLoaded, registerEquipmentCatalog, registerRuntimeEquipmentCatalog, subscribeRuntimeEquipmentRequests } from '@zep/game/registry';
import { buildAssetsUrl, resolveEquipmentCatalogAssetPaths } from '@zep/utils';
function isAbsoluteAssetPath(path: string): boolean {
  return /^https?:\/\//i.test(path) || path.startsWith('//') || path.startsWith('data:');
}
function resolveEquipmentAssetPath(path: string): string {
  if (isAbsoluteAssetPath(path)) {
    return path;
  }
  return buildAssetsUrl(path);
}
export function EquipmentCatalogBootstrapper() {
  const [runtimeCatalogGrants, setRuntimeCatalogGrants] = useState<string[]>([]);
  const service = useCurrentEquipmentService();
  const {
    isAuthenticated,
    isInitialized,
    user
  } = useAuth();
  const {
    data: inventory
  } = useEquipmentInventory({
    userHashId: user?.hashId,
    enabled: isInitialized && isAuthenticated
  });
  const {
    data
  } = useEquipmentCatalog(service, {
    inventory
  });
  const {
    data: runtimeCatalog
  } = useRuntimeEquipmentCatalog(runtimeCatalogGrants);
  useEffect(() => {
    const refreshRequestedGrants = () => {
      setRuntimeCatalogGrants(getRequestedRuntimeEquipmentCatalogGrants());
    };
    refreshRequestedGrants();
    return subscribeRuntimeEquipmentRequests(refreshRequestedGrants);
  }, []);
  useEffect(() => {
    if (!data) return;
    registerEquipmentCatalog(resolveEquipmentCatalogAssetPaths(data, resolveEquipmentAssetPath));
  }, [data]);
  useEffect(() => {
    if (!runtimeCatalog) return;
    registerRuntimeEquipmentCatalog(resolveEquipmentCatalogAssetPaths(runtimeCatalog, resolveEquipmentAssetPath));
    markRuntimeEquipmentCatalogGrantsLoaded(runtimeCatalogGrants);
  }, [runtimeCatalog, runtimeCatalogGrants]);
  return null;
}